import { render, staticRenderFns } from "./Turnos.vue?vue&type=template&id=70508db3&scoped=true&lang=pug"
import script from "./Turnos.vue?vue&type=script&lang=js"
export * from "./Turnos.vue?vue&type=script&lang=js"
import style0 from "./Turnos.vue?vue&type=style&index=0&id=70508db3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70508db3",
  null
  
)

export default component.exports